import React from 'react'

export const Main = () => {
  return (
    <main id='main' role='main'>
      fdgdfg
    </main>
  )
}

export default Main